<ds-listable-object-component-loader
  [object]="itemSearchResult"
  [viewMode]="viewMode"
  [linkType]="linkType">
</ds-listable-object-component-loader>
